module.exports = __webpack_public_path__ + "img/8.41b8f7c5.jpg";